export const environment = {
  production: false,
  environment: 'testing',
  client: 'operator-app',
  apiUrl: 'https://api.testing.smartparking.jjames.eu',
  edgeUrl: 'https://edge.testing.jjames.eu',
  parkerUrl: 'https://parker.testing.jjames.eu',
  paymentUrl: 'https://payment.testing.jjames.eu',
  // Sites whose zones only Administrators see (see auth/zone-visibility.ts). Temporary until a
  // Keycloak policy decides this. Wels Traunpark TG.
  zonesHiddenForSpaces: ['01a19d10-96b5-7758-ae1b-19f9db112c2f'] as string[],
  auth: {
    authority: 'https://auth.testing.smartparking.jjames.eu',
    realm: 'jjames',
    clientId: 'jjames-operator-frontend',
    clientBackend: 'jjames-backend'
  }
};
